export default __webpack_public_path__ + "static/media/headset1.45c6ec57.jfif";